import {getUserData, getUserRole, ROLE_SUPER_USER, ROLE_USER} from '../helpers'

export default (to, from, next) => {
  if (!getUserData()) {
    return next('/')
  }

  const currentUserRole = getUserRole().role
  const accessedRole = to.meta.access

  const baseRedirect = [ROLE_USER, ROLE_SUPER_USER].includes(currentUserRole) ? '/user' : '/admin'

  if (!accessedRole) {
    return next(baseRedirect)
  }

  if (!accessedRole.includes(currentUserRole)) {
    return next(baseRedirect)
  }

  next()
}



// WEBPACK FOOTER //
// /src/middleware/access.js